export const getUserLoginFlags = (
  securityProviderName,
  customRadio,
  aadRadio,
  isHybridIdentityTenant
) => {
  if (isHybridIdentityTenant && customRadio) {
    return {
      iscustomlogin: false,
      IsHybridCustom: true,
      IsHybridUser: true,
      IsSAMLUser: false,
    };
  }

  if (isHybridIdentityTenant && aadRadio) {
    return {
      iscustomlogin: false,
      IsHybridCustom: false,
      IsHybridUser: true,
      IsSAMLUser: true,
    };
  }

  if (securityProviderName === "saml2") {
    return {
      iscustomlogin: false,
      IsHybridCustom: false,
      IsHybridUser: false,
      IsSAMLUser: true,
    };
  }

  return {
    iscustomlogin: securityProviderName === "custom",
    IsHybridCustom: false,
    IsHybridUser: false,
    IsSAMLUser: false,
  };
};